import { Col, Row } from "react-bootstrap";
import { IThirdPartyCorrespondenceDetails } from "../../../api/IThirdPartyCorrespondence";
import EpaCard from "../../../leap-components/EpaCard";
import EpaField from "../../../leap-components/EpaField";
import EpaFieldHtml from "../../../leap-components/EpaFieldHtml";

interface ThirdPartyCorrespondenceDetailsProps {
  thirdPartyCorrespondence: IThirdPartyCorrespondenceDetails;
}

const ThirdPartyCorrespondenceDetails = ({
  thirdPartyCorrespondence,
}: ThirdPartyCorrespondenceDetailsProps) => {
  var bodyElements = (
    <div>
      <Row>
        <Col className="col-12 col-md-6">
          <EpaField
            label={"Original Correspondence Date"}
            value={thirdPartyCorrespondence.dateoforiginalcorrespondence}
          />
          <EpaField label={"Title"} value={thirdPartyCorrespondence.subject} />
          <EpaField
            label={"Received From"}
            value={thirdPartyCorrespondence.receivedfrom}
          />
        </Col>
        <Col className="col-12 col-md-6">
          <EpaField
            label={"Original Correspondence Received"}
            value={thirdPartyCorrespondence.dateoriginalcorrespondencereceived}
          />
          <EpaField
            label={"Correspondence Type"}
            value={thirdPartyCorrespondence.correspondencetype}
          />
        </Col>
      </Row>
      <Row>
        <Col className="col-12">
          <EpaFieldHtml
            label={"Inspector Update"}
            value={thirdPartyCorrespondence.inspectorsupdate}
            labelClassName={"col-12 col-md-12"}
            valueClassName={"col-12 col-md-12"}
          />
        </Col>
      </Row>
    </div>
  ) as JSX.Element;

  return (
    <EpaCard
      title={"EPA Initiated Correspondence Details"}
      content={bodyElements}
    />
  );
};

export default ThirdPartyCorrespondenceDetails;
